export type NextStepAction =
  | "probe"
  | "practice"
  | "answer_pending"
  | "assess"
  | "review"
  | "complete";

export interface NextStepRouteInput {
  action: string;
  bookId: string | null;
  knowledgePointId?: string | null;
}

export interface StudyLaunchInput {
  bookId?: string | null;
  bookKnowledgeBases?: ReadonlyMap<string, readonly string[]> | null;
  activeKnowledge?: string | null;
  persona?: string | null;
  engine?: { profile_id: string; model_id: string } | null;
}

export function buildBookKnowledgePointHref(
  bookId: string | null,
  knowledgePointId?: string | null,
): string {
  const params = new URLSearchParams();
  if (bookId) params.set("book", bookId);
  if (knowledgePointId) params.set("kp", knowledgePointId);
  const query = params.toString();
  return `/book${query ? `?${query}` : ""}`;
}

export function buildNextStepHref({
  action,
  bookId,
  knowledgePointId,
}: NextStepRouteInput): string {
  switch (action) {
    case "review":
      return "/notebook";
    case "complete":
      return "/book";
    case "probe":
    case "practice":
    case "answer_pending":
    case "assess":
      // 2단계 서술형 표면 전 임시 착지.
      return buildBookKnowledgePointHref(bookId, knowledgePointId);
    default:
      return buildBookKnowledgePointHref(bookId, knowledgePointId);
  }
}

export function nextStepCtaKey(action: string): string {
  switch (action) {
    case "probe":
      return "Start with a diagnostic";
    case "practice":
      return "Continue practicing";
    case "answer_pending":
      return "Answer remaining questions";
    case "assess":
      return "Check your understanding";
    case "review":
      return "Go review";
    case "complete":
      return "Create a new course";
    default:
      return "Continue learning";
  }
}

export function buildStudyHref({
  bookId,
  bookKnowledgeBases,
  activeKnowledge,
  persona,
  engine,
}: StudyLaunchInput): string {
  const params = new URLSearchParams();
  const knowledgeBases = bookId
    ? bookKnowledgeBases?.get(bookId)?.filter(Boolean)
    : undefined;
  const selectedKnowledgeBases =
    knowledgeBases && knowledgeBases.length > 0
      ? knowledgeBases
      : activeKnowledge
        ? [activeKnowledge]
        : [];

  if (selectedKnowledgeBases.length > 0) {
    params.set("kb", selectedKnowledgeBases.join(","));
  }
  if (bookId) params.set("book_id", bookId);
  if (persona) params.set("persona", persona);
  if (engine) params.set("engine", `${engine.profile_id}:${engine.model_id}`);

  const query = params.toString();
  return `/study${query ? `?${query}` : ""}`;
}
